export const formatContentSelectValueSingle = obj => {
  return {
    value: (obj || {})._id || (obj || {}).value,
    label: (obj || {}).nome || (obj || {}).label
  }
}

export default formatContentSelectValueSingle



// WEBPACK FOOTER //
// ./src/utils/formatContentSelectValueSingle.js